module.exports = __webpack_public_path__ + "img/photo-10.7c720e81.webp";